'use client';

import { PremiereTabs, TabsLayout } from '../../_components/Tabs';

/**
 * Layout for all routes that should display tabs.
 * Route groups like (with-tabs) don't affect the URL but let us organize
 * routes that share UI patterns. The pages within return null, so this layout
 * is responsible for rendering the tabs UI.
 */
export default function WithTabsLayout() {
  return (
    <TabsLayout data-testid="tabs-layout">
      <PremiereTabs />
    </TabsLayout>
  );
}
